<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <a class="navbar-brand mx-2" href="#">
            <img src="/assets/Agence-11h10-Logo-110.png" height="60px" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="/">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/connexion" *ngIf="!isLoggedIn">Connexion</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/builder-page">Page Builder</a>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto mb-2 mb-lg-0" *ngIf="isLoggedIn">
                <li class="nav-item">
                    <a class="nav-link" href="/builder-page">Mon profil</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="logout()">Se déconnecter</a>
                </li>
            </ul>
        </div>
    </div>
</nav>